import { render, staticRenderFns } from "./mention.vue?vue&type=template&id=845303de&"
import script from "./mention.vue?vue&type=script&lang=js&"
export * from "./mention.vue?vue&type=script&lang=js&"
import style0 from "./mention.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports